import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import RestHelper from "../../../../Helper/RestHelper";
import {RestResponse} from "../../../../Interfaces/RestResponse.interface";
import {Filterresponse} from "../../../../Interfaces/filterresponse.interface";
import {LoaderService} from "../../../../services/loader/loader.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Job} from "../../../../Interfaces/job.interface";
import {Customer} from "../../../../Interfaces/customer.interface";

@Component({
  selector: 'app-jobform',
  templateUrl: './jobform.component.html',
  styleUrl: './jobform.component.css'
})
export class JobFormComponent {

  public jobform: FormGroup = this.formBuilder.group({
    title: ["", [Validators.required, Validators.minLength(4)]],
    description: ["", [Validators.required]],
    customer: [],
    zipcode: ["", [Validators.required]],
    city: ["", [Validators.required]],
    district: [""],
    contracttype: ["", [Validators.required]],
    timemodel: ["", [Validators.required]],
    remote: ["", [Validators.required]],
    salary: [""],
    industry: ["", [Validators.required]],
    perspectives: ["", [Validators.required]],
    tasks: ["", [Validators.required]],
    requirements: ["", [Validators.required]],
    startdate: ["", [Validators.required]],
    published: ["", [Validators.required]]
  })
  public sentstatus: number = 0

  public industry_filter: any;
  public contracttype_filter: any;
  public timemodel_filter: any;
  public remote_filter: any;

  public operation: string | undefined
  public uuid: string | undefined
  public job: Job | undefined
  public customers: Customer[] | undefined

  public apierror: boolean = true

  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, protected loader: LoaderService, private route: ActivatedRoute, private router: Router) {
    this.loader.showLoader()
    this.route.params.subscribe(params => {
      this.operation = params['operation']
      this.uuid = params['uuid']
    });

    this.httpClient.get<RestResponse<Customer[]>>(RestHelper.API_BASE_URL + "customer/getCustomer", RestHelper.requestOptions).subscribe({
      next: (value) => {

        this.customers = value.data
        console.log(this.customers)

        this.httpClient.get<RestResponse<Filterresponse[]>>(RestHelper.API_BASE_URL + "searchfilter/getSearchFilter", RestHelper.requestOptions).subscribe({
          next: (value) => {

            this.industry_filter = value.data.filter(value1 => value1.filterName === "industry")?.at(0)?.filter
            this.contracttype_filter = value.data.filter(value1 => value1.filterName === "contract_type")?.at(0)?.filter
            this.timemodel_filter = value.data.filter(value1 => value1.filterName === "timemodel")?.at(0)?.filter
            this.remote_filter = value.data.filter(value1 => value1.filterName === "remote")?.at(0)?.filter

            if (this.operation === "edit" || this.operation === "delete") {
              if (this.uuid === undefined) {
                //TODO Error UUID ist benötigt wenn create, update oder delete
                return
              }

              this.httpClient.get<RestResponse<Job>>(RestHelper.API_BASE_URL + "job/getJob?admin=true&uuid=" + this.uuid, RestHelper.requestOptions).subscribe({
                next: (value) => {

                  this.job = value.data

                  console.log(value)

                  this.getFormControls()['title'].setValue(this.job.title)
                  this.getFormControls()['description'].setValue(this.job.description)
                  this.getFormControls()['customer'].setValue(this.job.customer)
                  this.getFormControls()['zipcode'].setValue(this.job.zipcode)
                  this.getFormControls()['city'].setValue(this.job.city)
                  this.getFormControls()['district'].setValue(this.job.district)
                  this.getFormControls()['contracttype'].setValue(this.job.contract_type)
                  console.log("Contracttype: " + this.job.contract_type)
                  console.log(this.getFormControls()['contracttype'].value)
                  console.log(this.contracttype_filter)
                  this.getFormControls()['timemodel'].setValue(this.job.timemodel)
                  this.getFormControls()['remote'].setValue(this.job.remote)
                  this.getFormControls()['salary'].setValue(this.job.salary)
                  this.getFormControls()['industry'].setValue(this.job.industry)
                  this.getFormControls()['perspectives'].setValue(this.job.perspectives)
                  this.getFormControls()['tasks'].setValue(this.job.tasks)
                  this.getFormControls()['requirements'].setValue(this.job.requirements)
                  this.getFormControls()['startdate'].setValue(this.job.start_date)
                  this.getFormControls()['published'].setValue(this.job.published ? "true" : "false")

                  if (this.operation === "delete") {
                    this.jobform.disable()
                  }
                }, error: () => {
                  this.apierror = true
                  this.loader.hideLoader()
                }
              })
            }

            this.loader.hideLoader()
            this.apierror = false

          }, error: () => {
            this.apierror = true
            this.loader.hideLoader()
          }
        })

      }, error: () => {
        this.apierror = true
        this.loader.hideLoader()
      }
    })
  }

  public getOperation(): string {
    switch (this.operation) {
      case "create":
        return "Erstellen"
      case "edit":
        return "Bearbeiten"
      case "delete":
        return "Löschen"
    }
    return ""
  }

  public onSubmit() {
    if (!this.jobform.valid) {
      this.jobform.markAllAsTouched()
      for (let el in this.jobform.controls) {
        if (this.jobform.controls[el].errors) {
          console.log(el)
        }
      }
      console.log("Form Invalid")
      return;
    }

    const body = new FormData();
    body.append("title", this.jobform.value.title)
    body.append("description", this.jobform.value.description)
    body.append("zipcode", this.jobform.value.zipcode)
    body.append("city", this.jobform.value.city)
    body.append("district", this.jobform.value.district)
    body.append("contract_type", this.jobform.value.contracttype)
    body.append("timemodel", this.jobform.value.timemodel)
    body.append("remote", this.jobform.value.remote)
    body.append("salary", this.jobform.value.salary)
    body.append("industry", this.jobform.value.industry)
    body.append("start_date", this.jobform.value.startdate)
    body.append("published", this.jobform.value.published)
    body.append("perspectives", this.jobform.value.perspectives)
    body.append("tasks", this.jobform.value.tasks)
    body.append("requirements", this.jobform.value.requirements)

    if (this.operation !== "create") {
      body.append("uuid", String(this.uuid))
    }

    body.append("customer", this.jobform.value.customer)
    body.append("career_level", "")
    body.append("education", "")
    body.append("expiry_date", "")

    if (this.operation === "create") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'job/createJob', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
            this.jobform.reset()
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    } else if (this.operation === "edit") {

      this.httpClient.put(RestHelper.API_BASE_URL + 'job/updateJob', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    }
  }

  public deleteJob(event: Event, uuid: string) {

    event.preventDefault()
    event.stopPropagation();

    const body = new FormData();

    body.append("uuid", uuid)

    this.httpClient.request("DELETE", RestHelper.API_BASE_URL + 'job/deleteJob', {body})
      .subscribe({
        next: () => {
          this.jobform.reset()
          this.router.navigateByUrl('/admin/jobs').then(value => {
            if (!value) {
              console.error("Konnte nicht auf Jobübersicht umleiten")
            }
          })
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public getFormControls() {
    return this.jobform.controls;
  }

  protected readonly Validators = Validators;
}
